var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "menu--item_group" },
    [
      _vm._l(_vm.section.grouped_items, function (group, groupTitle) {
        return [
          groupTitle.length && !group.hasOwnProperty(groupTitle)
            ? _c(
                "h3",
                { staticClass: "menu--section_group_title" },
                [
                  groupTitle === "HOUSEMADE GELATO"
                    ? _c("menu-tag", {
                        attrs: {
                          tag: _vm.dummyContainsNutsMenuTag,
                          "menu-type": "visual",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(groupTitle))]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(group, function (subgroup, subgroupTitle) {
            return [
              _c("section-item-subgroup", {
                attrs: {
                  "menu-item-tag-location": _vm.menuItemTagLocation,
                  "menu-item-component": _vm.menuItemComponentOverride,
                  section: _vm.section,
                  "pricing-types":
                    _vm.itemGroupPricingTypes[groupTitle][subgroupTitle],
                  layout: _vm.layout,
                  items: subgroup,
                  "is-subgroup-pricing-shown": _vm.isSubgroupPricingShown(
                    groupTitle,
                    subgroupTitle
                  ),
                  "group-title": groupTitle,
                  "subgroup-title": subgroupTitle,
                },
              }),
            ]
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }